import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B02icCustomerUserListPage } from '../b02ic-customer-user-list/b02ic-customer-user-list';
import { B02iCustomerManagementPage } from '../b02i-customer-management/b02i-customer-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B02idCustomerUserAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b02id-customer-user-add',
  templateUrl: 'b02id-customer-user-add.html',
})
export class B02idCustomerUserAddPage {
  private todo : FormGroup;
  loading: any;
  Status: any;

  userData =  { LOGIN: '', PASSWORD:'', USER_NAME:'',
                BRANCH_ID: null, GRP_ID: '', CORP_ID: '', 
                USER_ACTIVE:'YES',
              }
  Password1: any;
  Password2: any;
  public errorMessage: any = "";

  constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, 
              public serviceapi: ServiceApiProvider, public loadingCtrl: LoadingController) {

    this.todo = this.formBuilder.group({
      username: ['', Validators.required],
      usergroup: ['', Validators.required],
      password1: ['', Validators.required],
      password2: ['', Validators.required],
      active: ['', Validators.required],
    });

    this.userData.CORP_ID = this.navParams.get('paramCorpId');    //corporate ID
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B02idCustomerUserAddPage');
  }

  save(){
    if (this.validateNoSpecialContain(this.userData.USER_NAME) != true) {
      this.errorMessage = "Username Contains Invalid Characters";
    }
    else if (this.Password1 != this.Password2) {                //check password 1 match with password 2
      this.errorMessage = "Password Mismatch";
    }
    else {
      this.userData.PASSWORD = this.Password1;                  //assign password
      delete this.userData.BRANCH_ID;                           //delete branch ID, not use
      delete this.userData.LOGIN;                               //delete login, not use
      console.log(this.userData);
      this.showLoader();
      this.serviceapi.insertdata("USER",this.userData).then((result) => {
        this.loading.dismiss();
        this.Status = result["Message"];
        
        if (this.Status == "1"){
          this.navCtrl.setRoot(B02icCustomerUserListPage, {paramID: this.userData.CORP_ID});
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        }
      }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
      });
    }
  }

  cancel(){
    this.navCtrl.pop();
  }

  goTo(){                                               //page nevigation link 1
    this.navCtrl.setRoot(B02iCustomerManagementPage);
  }

  goTo2(){                                              //page nevigation link 2
    this.navCtrl.setRoot(B02icCustomerUserListPage, {paramID: this.userData.CORP_ID});
  }

  showLoader(){    
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }

  validateNoSpecialContain(s) {
    //Regex for Valid Characters i.e. Alphabets, Numbers.
    var regex = /^[A-Za-z0-9_]+$/

    //Validate TextBox value against the Regex.
    var isValid = regex.test(s);

    return isValid;
  }
}



// WEBPACK FOOTER //
// ./src/pages/b02id-customer-user-add/b02id-customer-user-add.ts